<template>
	<v-container pa-0 d-flex justify-center full-width>
		<v-layout justify-center column style="max-width: 600px">
			<div class="d-flex align-center full-width">
				<v-layout class="full-width" @click="modal = true">
					<v-dialog
						ref="dialog"
						v-model="modal"
						:return-value.sync="startDate"
						persistent
						width="270px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-flex class="px-1">
								<v-text-field
									v-model="displayStartDate"
									label="Select Start Date"
									v-bind="attrs"
									v-on="on"
									prepend-icon="today"
									placeholder="Start Date"
									class="text-field-wrapper pt-4"
								></v-text-field>
							</v-flex>
						</template>
						<v-date-picker
							v-model="startDate"
							:show-current="false"
							no-title
							elevation="15"
							:color="themeInputColor"
							class="btn"
							min="2021-08-03"
							width="270px"
						>
							<v-spacer></v-spacer>
							<v-btn
								text
								:color="themeInputColor"
								class="btn white--text"
								@click="modal = false"
							>
								Cancel
							</v-btn>
							<v-btn
								text
								:color="themeInputColor"
								class="btn white--text"
								@click="() => setDate(true)"
							>
								OK
							</v-btn>
						</v-date-picker>
					</v-dialog>
				</v-layout>
				<div>TO</div>
				<v-layout
					class="full-width"
					@click="endDateModal = !!startDate"
				>
					<v-dialog
						ref="endDateDialog"
						v-model="endDateModal"
						:return-value.sync="endDate"
						persistent
						width="270px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-flex class="px-1">
								<v-text-field
									v-model="displayEndDate"
									label="Select End Date"
									v-bind="attrs"
									v-on="on"
									prepend-icon="today"
									placeholder="End Date"
									class="text-field-wrapper pt-4"
									:disabled="!startDate"
								></v-text-field>
							</v-flex>
						</template>
						<v-date-picker
							v-model="endDate"
							:show-current="false"
							no-title
							elevation="15"
							:color="themeInputColor"
							class="btn"
							:min="startDate"
							:max="addDaysToDate(startDate, 59)"
							:disabled="!startDate"
							width="270px"
						>
							<v-spacer></v-spacer>
							<v-btn
								text
								:color="themeInputColor"
								class="btn white--text"
								@click="endDateModal = false"
							>
								Cancel
							</v-btn>
							<v-btn
								text
								:color="themeInputColor"
								class="btn white--text"
								@click="() => setDate(false)"
							>
								OK
							</v-btn>
						</v-date-picker>
					</v-dialog>
				</v-layout>
			</div>
			<v-flex
				class="border-4 white--text mt-2 pa-4"
				:style="{ backgroundColor: themeInputColor }"
				v-if="showTotalCommission"
			>
				<div class="big-font">Total Commission Earned</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{ totalCommission.toFixed(2).toLocaleString() }}
				</div>
				<div class="big-font pt-3">Total Unpaid Commission</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{ unpaidCommission.toFixed(2).toLocaleString() }}
				</div>
			</v-flex>
			<v-flex
				class="border-4 white--text mt-2 pa-4"
				:style="{ backgroundColor: themeInputColor }"
				v-if="!showTotalCommission"
			>
				<div class="big-font">Commission Earned</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{ commissionForDateRange.toFixed(2).toLocaleString() }}
				</div>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { MONTHS, RUMMY_COLOUR, THEME_INPUT_COLOUR } from "../../constants";
import infiniteScroll from "vue-infinite-scroll";
import { FETCH_RETAILER_COMMISSION } from "../../../store/action-types";

export default {
	data() {
		return {
			modal: false,
			endDateModal: false,
			startDate: "",
			endDate: "",
			displayStartDate: "",
			displayEndDate: "",
			MONTHS: MONTHS,
			totalCommission: 0,
			unpaidCommission: 0,
			commissionForDateRange: 0,
			showTotalCommission: true
		};
	},
	directives: { infiniteScroll },
	methods: {
		fetchRetailerCommission() {
			const sendDatesAsPayload = this.startDate && this.endDate;
			this.$store
				.dispatch(FETCH_RETAILER_COMMISSION.dispatch, {
					...(sendDatesAsPayload
						? {
								startDate: this.startDate,
								endDate: this.addDaysToDate(this.endDate, 1),
								isRummyOptionSelected: this
									.isRummyOptionSelected
						  }
						: {})
				})
				.then(data => {
					if (!sendDatesAsPayload) {
						this.totalCommission = data.totalCommission || 0;
						this.unpaidCommission = data.unpaidCommission || 0;
					} else {
						this.commissionForDateRange = data.commission || 0;
					}
				})
				.catch(() => {});
		},
		getDateToDisplay(date) {
			const [stYear, stMonth, stDate] = date.split("-");
			return `${stDate} ${MONTHS[Number(stMonth) - 1].substr(
				0,
				3
			)} ${stYear.substr(2)}`;
		},
		setDate(isStartDate) {
			if (isStartDate) {
				this.$refs.dialog.save(this.startDate);
				this.displayStartDate = this.getDateToDisplay(this.startDate);
			} else {
				this.$refs.endDateDialog.save(this.endDate);
				this.displayEndDate = this.getDateToDisplay(this.endDate);
			}
			if (this.startDate && this.endDate) {
				this.fetchRetailerCommission();
				this.showTotalCommission = false;
			}
		},
		addDaysToDate(date, days) {
			if (!date) return "";
			const finalDate = new Date(
				new Date(date).setDate(new Date(date).getDate() + Number(days))
			);
			return finalDate.toISOString().substr(0, 10);
		}
	},
	computed: {
		themeInputColor() {
			return this.isRummyOptionSelected
				? RUMMY_COLOUR
				: THEME_INPUT_COLOUR;
		}
	},
	props: ["isRummyOptionSelected"],
	mounted() {
		// this.fetchRetailerCommission();
	}
};
</script>
<style scoped>
.big-font {
	font-size: 14px;
	font-weight: 500;
}
.bigger-font {
	font-size: 24px;
	font-weight: 500;
}
.huge-font {
	font-size: 30px;
	font-weight: 500;
}
.border-4 {
	border-radius: 4px;
}
</style>
